<template>
  <div class="">
    <p
      v-if="!hideLabel"
      class="flex items-center gap-2 mb-1 pl-4 text-sm font-medium dark:text-gray-100 text-primary h-5"
    >
      {{ $t(label || "") }}<span v-if="required" class="text-danger"> *</span>
    </p>
    <div class="flex items-center">
      <div class="flex items-center">
        <input
          :type="type"
          :id="id"
          :name="name"
          :checked="modelValue == checkedValue"
          :value="checkedValue"
          @change="onChange"
          :disabled="disabled"
          class="text-primary transition-all duration-100 ease-out form-checkbox rounded-sm"
          :class="[
            {
              'input-error': errorMessage,
            },

            size ? 'h-7 w-7 md:h-10 md:w-10' : small ? 'h-4 w-4' : 'h-5 w-5',
          ]"
        />
        <label :for="id"></label>
      </div>
      <label
        :for="id"
        class="ml-3 flex items-center gap-2 "
        :class="[
          { 'text-secondary': errorMessage },
          { 'text-lg md:text-2xl font-semibold': size },
          { 'text-primary/50': disabled },
          small ? 'text-gray-500 dark:text-gray-500 text-sm' : 'dark:text-gray-500',
        ]"
        ><slot>{{ $t(text || "") }}</slot>
        <tippy v-if="tooltip" class="flex items-center justify-center">
          <BaseIcon name="info" class="text-success hover:ring-success" />
          <template #content>
            <slot name="tooltip" />
          </template> </tippy
      ></label>
    </div>
    <template v-if="single">
      <span v-show="errorMessage" class="text-danger dark:text-danger">
        {{ $t(errorMessage || "") }}
      </span>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { toRef, toRefs,  ref } from "vue";

const emit = defineEmits(["update:modelValue"]);
const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  text: String,
  name: String,
  type: {
    type: String,
    default: "checkbox",
  },
  size: {
    type: Boolean,
    default: false,
  },
  id: String,
  placeholder: String,
  cvalue: {
    type: [Boolean, String, Number],
    default: false,
  },
  modelValue: {
    type: [Boolean, String, Number],
    default: true,
  },
  btn: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
  single: {
    type: Boolean,
    default: false,
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
  small: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  checkedValue: {
    type: [Boolean, String, Number],
    default: true,
  },
  uncheckedValue: {
    type: [Boolean, String, Number],
    default: false,
  },
});

const errorMessage = ref(null);
const { checkedValue, uncheckedValue, modelValue, name } = toRefs(props);

const onChange = (e) => {
  const v = e.target.checked ? checkedValue.value : uncheckedValue.value;
  emit("update:modelValue", v);
};
</script>

<style scoped></style>
